import React from 'react'
import RoleTable from 'components/Tables/Role/RoleTabe'
import CatagoryTable from 'components/Tables/catagory/CatagoryTable'

const ListCatagory = () => {
  return (
    <div><CatagoryTable /></div>
  )
}

export default ListCatagory